import React, { useEffect, useState } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import { Alert } from "react-bootstrap";
import Pagination from "react-js-pagination";
import GeneralFilter from "../../../components/GeneralFilter";
import { getCasesByStatuses } from "../../services/casesService";
import GeneralTable from "../../../components/GeneralTable";
import CaseContext from "../../../contexts/CaseContext";
import { IfHasRoleByLocalStorage } from "../../../../_metronic/_helpers";

const MedicalOpinion = () => {
  window.currModule = "Dictamen Medico";
  window.assignationColumn = "feadictamen";

  const suhbeader = useSubheader();
  suhbeader.setTitle("DICTAMEN MÉDICO");

  const [casesRecord, setCasesRecord] = useState([]);
  const [paramsPagination, setParamsPagination] = useState({
    activePage: 1,
    totalPages: null,
    itemsCountPerPage: null,
    totalItemsCount: 0,
  });

  const getAllCasesByStatus = (pageNumber) => {
    var queryParams = [];

    if (IfHasRoleByLocalStorage("ADMIN_REGION_CELULA")) {
      queryParams = ['&byRegion=true', '&byCell=true'];
    }

    getCasesByStatuses([5], pageNumber, queryParams).then((response) => {
      setCasesRecord(response.data);

      setParamsPagination({
        activePage: pageNumber,
        totalPages: response.totalPages,
        itemsCountPerPage: response.size,
        totalItemsCount: response.totalElements,
      });
    });
  }

  const handlePageChange = async (pageNumber) => {
    setParamsPagination({ ...paramsPagination, activePage: pageNumber, updatePage: true });

    if (!paramsPagination.hasOwnProperty("fromFilter")) {
      getAllCasesByStatus(pageNumber);
    }
  }

  useEffect(() => {
    getAllCasesByStatus(paramsPagination.activePage);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Alert
        variant="success"
        className="text-center"
        style={{ fontSize: "16px" }}
      >
        DICTAMEN MÉDICO
      </Alert>

      <CaseContext.Provider value={[
        casesRecord, setCasesRecord,
        paramsPagination, setParamsPagination
      ]}>
        <GeneralFilter
          statuses={[5]}
          hideInsurance={true}
          hideHospitalInvoice={true}
          hidePresumptiveDiagnosis={true}
          hideCategoryVip={true}
        />
      </CaseContext.Provider>

      <GeneralTable
        urlToGo="/dictamen_medico_detalles/"
        data={casesRecord}
        activePage={paramsPagination.activePage}
        totalItemsCount={paramsPagination.totalItemsCount}
        hidePatientStatusColumn={true}
        hideCelulaColumn ={false}
        reason="Dictum"
        assignationColumn="feadictamen"
        currModule="Dictamen Medico"
      />

      <div className="d-flex justify-content-center">
        <Pagination
          activePage={paramsPagination.activePage}
          itemsCountPerPage={paramsPagination.itemsCountPerPage}
          totalItemsCount={paramsPagination.totalItemsCount}
          pageRangeDisplayed={10}
          itemClass="page-item"
          linkClass="btn btn-light"
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export default MedicalOpinion;
